<template>
  <el-dialog
    width="104.375rem"
    title="查看试卷"
    :close-on-click-modal="false"
    :visible.sync="lookPaperVisible"
    class="inner-dialog"
    append-to-body
  >
    <div class="all">
      <div class="left">
        <div class="test-title">
          <div class="one-line">{{ paperData.name }}</div>
          <div class="two-line">
            <span>分值{{ totalScore }}分</span>
          </div>
        </div>
        <div class="normal-area" v-for="(i, k) in bucketData" :key="k">
          <div class="tips">{{ i.title }} (共{{ i.score }}分)</div>
          <div
            class="test-style"
            v-for="(item, index) in i.data"
            :key="index"
            :id="item.questionsId"
          >
            <div class="header-title">
              <div
                style="display: flex;"
                v-html="index + 1 + '.' + item.questionStem"
              ></div>
              <div style="width: 100px;text-align: right;">
                {{ item.score || 0 }}分
              </div>
            </div>
            <div class="bottom-option">
              <div
                class="option"
                v-for="temp in item.qaList"
                :key="temp.answerId"
              >
                {{ temp.answerFLag }} {{ temp.answerStem }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="right-top" v-if="isEdit">
          <div class="set-grade" @click="openScore">设置分数</div>
          <div class="submit-test" @click="submitPaper">保存试卷</div>
        </div>
        <div class="right-bottom">
          <div class="header-title">
            <div class="tips-text">试卷信息</div>
            <div v-if="isEdit" class="right-text" @click="removeAll">
              <span>清空试题篮</span>
            </div>
          </div>
          <div class="bottom-content">
            <div v-for="(i, k) in bucketData" :key="k">
              <div class="tips">
                <div>{{ i.title }}</div>
              </div>
              <div class="numbers-area">
                <a
                  :class="[
                    'number',
                    { currentNum: currentId === item.questionsId }
                  ]"
                  v-for="(item, index) in i.data"
                  :key="index"
                  @click="scrollTo(item.questionsId)"
                  >{{ index + 1 }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { lookPaperInfo, savePaper, editPaper } from "@/api/manage";
export default {
  name: "viewDialog",

  data() {
    return {
      activeIndex: "",
      paperData: {},
      lookPaperVisible: false,
      currentId: "",
      isEdit: "",
      bucketData: {
        1: {
          title: "一、单选题",
          data: [],
          score: 0
        },
        2: {
          title: "二、判断题",
          data: [],
          score: 0
        },
        3: {
          title: "三、多选题",
          data: [],
          score: 0
        }
      }
    };
  },
  computed: {
    totalScore() {
      let total = 0;
      for (let i in this.bucketData) {
        for (let j in this.bucketData[i].data) {
          total += Number(this.bucketData[i].data[j].score);
        }
      }
      return Number(total);
    }
  },
  methods: {
    async open(type, item, data = []) {
      try {
        this.isEdit = type;
        this.paperData = item;
        this.lookPaperVisible = true;
        this.reset();
        if (type) {
          data.forEach((item, index) => {
            this.bucketData[item.questionType].data.push(item);
            this.bucketData[item.questionType].score = Number(
              this.bucketData[item.questionType].score + Number(item.score || 0)
            );
          });
        } else {
          const res = await lookPaperInfo(item.questionPaperId);
          res.data.data.forEach((item, index) => {
            this.bucketData[item.questionType].data.push(item);
            this.bucketData[item.questionType].score = Number(
              this.bucketData[item.questionType].score + Number(item.score || 0)
            );
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    reset() {
      this.bucketData = {
        1: {
          title: "一、单选题",
          data: [],
          score: 0
        },
        2: {
          title: "二、判断题",
          data: [],
          score: 0
        },
        3: {
          title: "三、多选题",
          data: [],
          score: 0
        }
      };
    },

    openScore() {
      this.$emit("openScore", this.paperData, this.bucketData);
    },
    setScore(data) {
      this.bucketData = data;
    },
    removeAll() {
      for (let i in this.bucketData) {
        this.bucketData[i].data = [];
        this.bucketData[i].score = 0;
      }
      this.$emit("clearBucket");
      this.lookPaperVisible = false;
      this.$message({ type: "success", message: "试题篮已清空，请重新添加" });
    },
    scrollTo(id) {
      this.currentId = id;
      document.getElementById(id).scrollIntoView({
        block: "start",
        behavior: "instant"
      });
    },
    async submitPaper() {
      if (this.totalScore > 0) {
        let params = [];
        for (let i in this.bucketData) {
          for (let j in this.bucketData[i].data) {
            params.push({
              questionId: this.bucketData[i].data[j].questionsId,
              score: this.bucketData[i].data[j].score,
              questionPaperId: this.paperData.questionPaperId
            });
          }
        }
        const res = await savePaper(params);
        if (res.data.code === 200) {
          this.lookPaperVisible = false;
          await editPaper({ ...this.paperData, ...{ score: this.totalScore } });
          this.$emit("success");

          this.$message({
            showClose: true,
            message: "试卷保存成功",
            type: "success"
          });
        }
      } else {
        this.$message({
          showClose: true,
          message: "请设置试题分数",
          type: "error"
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.inner-dialog {
  /deep/ .el-dialog {
    margin: 0 !important;
    margin-left: 15rem !important;
    margin-top: 78px !important;
    height: calc(100vh - 90px);
  }

  /deep/ .el-dialog__body {
    padding: 1.25rem;
    height: calc(100vh - 184px);
  }

  .all {
    height: 100%;
    display: flex;

    .left {
      height: 100%;
      width: 79%;
      border: 1px solid #e5eaf4;
      padding: 1.875rem 1.25rem 1.25rem 1.25rem;
      box-sizing: border-box;
      overflow-y: auto;
      margin-right: 1%;

      .test-title {
        text-align: center;
        background: #f6f9ff;
        border: 1px solid #d1daec;
        border-radius: 0.625rem;
        width: 25rem;
        height: 4.375rem;
        margin: 0 auto;
        padding-top: 0.5rem;
        box-sizing: border-box;

        .one-line {
          font-size: 1.25rem;
          font-family: PingFangSC-Regular, PingFang SC;
          // font-weight: 500;
          color: #434449;
        }

        .two-line {
          span {
            font-size: 0.875rem;
            font-family: PingFangSC-Regular, PingFang SC;
            // font-weight: 500;
            color: #919398;
          }
        }
      }

      .normal-area {
        .tips {
          font-size: 0.875rem;
          font-family: PingFangSC-Regular, PingFang SC;
          // font-weight: 500;
          color: #434449;
          margin: 1rem 0;
        }

        .test-style {
          border: 1px solid #e5eaf4;
          box-sizing: border-box;
          margin-bottom: 0.5rem;

          .header-title {
            display: flex;
            justify-content: space-between;
            padding: 0 1.25rem;
            background: #fafafa;
            // height: 2.8125rem;
            line-height: 2.8125rem;
            font-size: 0.875rem;
            font-family: PingFangSC-Regular, PingFang SC;
            // font-weight: 500;
            color: #434449;
          }

          .bottom-option {
            padding: 1.25rem 2.4rem;

            div {
              margin-bottom: 0.5rem;
              font-size: 0.875rem;
              font-family: PingFangSC-Regular, PingFang SC;
              // font-weight: 500;
              color: #434449;
            }
          }
        }

        .test-style:last-child {
          margin-bottom: 0;
        }
      }
    }

    .right {
      width: 20%;
      display: flex;
      flex-direction: column;

      .right-top {
        border: 1px solid #e5eaf4;
        margin-bottom: 1.25rem;
        width: 20.625rem;
        height: 11.25rem;
        padding-top: 1.875rem;
        box-sizing: border-box;

        .set-grade {
          background: #1890ff;
          font-size: 1rem;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #ffffff;
          margin-bottom: 1.25rem;
          cursor: pointer;
        }

        .submit-test {
          border: 1px solid #1890ff;
          font-size: 1rem;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #1890ff;
          cursor: pointer;
        }

        div {
          width: 16.25rem;
          height: 3.125rem;
          text-align: center;
          line-height: 3.125rem;
          border-radius: 0.1875rem;
          box-sizing: border-box;
          margin: 0 auto;
        }
      }

      .right-bottom {
        border: 1px solid #e5eaf4;
        padding: 1rem 1.25rem 0 1.25rem;
        // height: 37.5rem;
        flex: 1;
        overflow-y: auto;
        box-sizing: border-box;
        overflow: auto;

        .header-title {
          display: flex;
          justify-content: space-between;
          padding-left: 0.25rem;
          margin-bottom: 1rem;
          align-items: center;

          .tips-text {
            font-size: 1rem;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #434449;
          }

          .right-text {
            // background: #2D8CF0;
            // opacity: 0.2;
            border-radius: 0.1875rem;
            background: rgba(45, 140, 240, 0.2);
            width: 5.25rem;
            height: 1.75rem;
            line-height: 1.75rem;
            text-align: center;
            font-size: 0.875rem;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #1890ff;
            cursor: pointer;
          }
        }

        .bottom-content {
          .tips {
            display: flex;
            justify-content: space-between;
            font-size: 0.875rem;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #434449;
            margin-bottom: 1rem;

            // padding: 0 1.25rem;
            .remove {
              color: #c8c8c8;
              cursor: pointer;
            }
          }

          .numbers-area {
            display: flex;
            // justify-content:space-between;
            flex-wrap: wrap;

            .number {
              // width: %;
              // width: 3.125rem;
              width: 18%;
              margin-right: 1%;
              height: 2.1875rem;
              line-height: 2.1875rem;
              text-align: center;
              background: #ffffff;
              border: 1px solid #d1daec;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              color: #434449;
              margin-bottom: 0.5rem;
              cursor: pointer;
              text-decoration: none;
              box-sizing: border-box;
            }

            .currentNum {
              background: #f6f9ff;
              border: 1px solid rgba(24, 144, 255, 1);
            }

            .number:nth-child(5n) {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Paper/Theory/BucketDialog.vue